import { ApiConfig } from "../apiConfig/apiConfig";
import { ApiCallGet } from "../apiConfig/apiCall";

const headers = { "Content-Type": "application/json" };

const BlogService = {
  getBlogCategories: async () => {
    const { baseBlogs, blogCategories } = ApiConfig;
    return ApiCallGet(baseBlogs + blogCategories, headers);
  },

  getBlogs: async ({ page = 1, limit = 12, search = "", category = "" } = {}) => {
    const { baseBlogs, publicBlogs } = ApiConfig;
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (search) params.set("search", search);
    if (category) params.set("category", category);
    return ApiCallGet(`${baseBlogs}${publicBlogs}?${params.toString()}`, headers);
  },

  getBlogBySlug: async (slug) => {
    const { baseBlogs, publicBlogs } = ApiConfig;
    return ApiCallGet(`${baseBlogs}${publicBlogs}/${encodeURIComponent(slug)}`, headers);
  },
};

export default BlogService;
